//浅色模式颜色配置

export default {
  color1: '#333',
  color2: '#333',
  border_color: '#eee',
  bg_color1: '#fff',
  bg_color2: '#fff',
  bg_color: '#fff',
  tab_bg_color: '#f6f6f8',
  text_clolor: '#9696A6',
  toast_text: '#9696A6',
  toast_bg_color: '#f6f6f8',
  active_bg_color: '#fbf2e7',
  card_bg_color: '#fff',
  activity_state_color: '#511e21',
  nodata_img: require(`@/img/user-new/no_data.png`),
  box_shadow: '0px 2px 8px  0.4px rgba(0, 0, 0, 0.1), 0px 2px 8px 0.4px  rgba(0, 0, 0, 0.1)',
  invite_bg: 'linear-gradient(180deg, rgba(255,152,143,0.99) 0%, rgba(255,255,255,0)  376px)',
  invite_text: '#353535',
  invite_card_bg: 'linear-gradient(0deg, #FFFFFF 24%, #FFD6D2 100%)',
  ellipsis_color: '#333',
  loading_img: require('@/img/loading.gif'),
}


// WEBPACK FOOTER //
// ./src/styles/light.js